/* eslint-disable prettier/prettier */
import React from 'react';
import { ActivityType } from '../../types/schedule.types';
import { ACTIVITY_TYPES } from '../../constants/activitytypes.constant';
import ActivityTypeChip from './ActivityTypeChip';
import styles from '../../styles/Schedule/ActivityTypeFilter.module.css';

interface ActivityTypeFilterProps {
	activeFilters: Set<ActivityType>;
	onToggle: (type: ActivityType) => void;
}

const ActivityTypeFilter: React.FC<ActivityTypeFilterProps> = ({
	activeFilters,
	onToggle,
}) => {
	return (
		<div className={styles.filterBar}>
			<span className={styles.label}>Activity Types:</span>
			<div className={styles.chips}>
				{ACTIVITY_TYPES.map(config => (
					<ActivityTypeChip
						key={config.id}
						config={config}
						isActive={activeFilters.has(config.id)}
						onToggle={() => onToggle(config.id)}
					/>
				))}
			</div>
		</div>
	);
};

export default ActivityTypeFilter;
